var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('producto-form',{attrs:{"idBusiness":_vm.idBusiness,"idProducto":_vm.idProducto,"idSectorParam":_vm.idSector,"filtro":_vm.filtro,"pag":_vm.pag}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9dfa84a2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Dashboard/Configuracion/Productos/Producto.vue
// module id = gQA5
// module chunks = 4